import { Record, Union } from "../../fable_modules/fable-library-js.4.19.3/Types.js";
import { tuple_type, list_type, record_type, bool_type, option_type, unit_type, union_type, lambda_type, class_type } from "../../fable_modules/fable-library-js.4.19.3/Reflection.js";
import { Model_$reflection, OutboundMsg_$reflection as OutboundMsg_$reflection_1, InboundMsg_$reflection as InboundMsg_$reflection_1, LocalMsg_$reflection as LocalMsg_$reflection_1 } from "./AnalysisFormFileManagement/AnalysisFormFileTypes.js";
import { Msg$3_$reflection } from "../../Common/InboundOutbound.js";
import { AnalysisViewModel_$reflection } from "../../RAWMap.Models/View/Analysis.js";
import { ErrorMessage_$reflection } from "../../RAWMap.Models/ErrorMessage.js";
import { FSharpResult$2 } from "../../fable_modules/fable-library-js.4.19.3/Result.js";
import { PatientCreationViewModel_$reflection, HospitalPatientIdViewModel_$reflection, NameDobViewModel_$reflection } from "../../RAWMap.Models/View/Patient.js";
import { Common_ReportType_$reflection } from "../../RAWMap.Models/Common.js";
import { StudyViewModel_$reflection } from "../../RAWMap.Models/View/Study.js";
import { S3Context_$reflection } from "../../Common/AwsCommon.js";
import { InstitutionViewModel_$reflection } from "../../RAWMap.Models/View/Institution.js";
import { UserRole_$reflection } from "../../RAWMap.Models/Security.js";

export class LocalMsg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Noop", "ExceptionError", "ReportExceptionError", "AnalysisDataFileManagerMsg", "IntermediateZipFileManagerMsg", "TrySendIntermediateZipFileMessage", "UiDataFileManagerMsg", "TrySendUiDataFileMessage", "SetAnalysisVm", "UpdateValidation", "EditAnalysis", "SaveAnalysis", "CreateAnalysisResult", "EditAnalysisResult", "SetNameDobVM", "HospitalPatientId", "ValidateReportTypeFields", "GetReportType", "DownloadReport", "PrependTitlePage", "PrependTitlePageResult", "SetReportType", "PatientInfoValidationResults", "Cancel"];
    }
}

export function LocalMsg_$reflection() {
    return union_type("Client.Study.AnalysisForm.Types.LocalMsg", [], LocalMsg, () => [[], [["Item", class_type("System.Exception")]], [["Item", class_type("System.Exception")]], [["Item", Msg$3_$reflection(LocalMsg_$reflection_1(), InboundMsg_$reflection_1(), OutboundMsg_$reflection_1())]], [["Item", Msg$3_$reflection(LocalMsg_$reflection_1(), InboundMsg_$reflection_1(), OutboundMsg_$reflection_1())]], [["Item1", Model_$reflection()], ["Item2", Msg$3_$reflection(LocalMsg_$reflection_1(), InboundMsg_$reflection_1(), OutboundMsg_$reflection_1())]], [["Item", Msg$3_$reflection(LocalMsg_$reflection_1(), InboundMsg_$reflection_1(), OutboundMsg_$reflection_1())]], [["Item1", Model_$reflection()], ["Item2", Msg$3_$reflection(LocalMsg_$reflection_1(), InboundMsg_$reflection_1(), OutboundMsg_$reflection_1())]], [["Item", lambda_type(AnalysisViewModel_$reflection(), AnalysisViewModel_$reflection())]], [], [], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [AnalysisViewModel_$reflection(), ErrorMessage_$reflection()], FSharpResult$2, () => [[["ResultValue", AnalysisViewModel_$reflection()]], [["ErrorValue", ErrorMessage_$reflection()]]])]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [AnalysisViewModel_$reflection(), ErrorMessage_$reflection()], FSharpResult$2, () => [[["ResultValue", AnalysisViewModel_$reflection()]], [["ErrorValue", ErrorMessage_$reflection()]]])]], [["Item", lambda_type(NameDobViewModel_$reflection(), NameDobViewModel_$reflection())]], [["Item", lambda_type(HospitalPatientIdViewModel_$reflection(), HospitalPatientIdViewModel_$reflection())]], [], [], [], [["Item", class_type("PdfLib.IPdfDocument")]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, ErrorMessage_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", ErrorMessage_$reflection()]]])]], [["Item", option_type(Common_ReportType_$reflection())]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [bool_type, ErrorMessage_$reflection()], FSharpResult$2, () => [[["ResultValue", bool_type]], [["ErrorValue", ErrorMessage_$reflection()]]])]], []]);
}

export class OutboundMsg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ActiveAnalysisModified", "SuccessfulAnalysisCreation", "ReportFileDeleted", "CancelSelection", "VisualizeData"];
    }
}

export function OutboundMsg_$reflection() {
    return union_type("Client.Study.AnalysisForm.Types.OutboundMsg", [], OutboundMsg, () => [[["Item", AnalysisViewModel_$reflection()]], [["Item", AnalysisViewModel_$reflection()]], [], [], [["Item1", StudyViewModel_$reflection()], ["isStentPlanning", bool_type]]]);
}

export class InboundMsg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["UpdateActiveAnalysis", "UpdateActiveStudy", "GotCredentials"];
    }
}

export function InboundMsg_$reflection() {
    return union_type("Client.Study.AnalysisForm.Types.InboundMsg", [], InboundMsg, () => [[["Item", AnalysisViewModel_$reflection()]], [["Item", StudyViewModel_$reflection()]], [["Item1", class_type("Fable.Import.Aws.Credentials.Credentials")], ["Item2", S3Context_$reflection()]]]);
}

export class InternalMsg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Local", "Inbound"];
    }
}

export function InternalMsg_$reflection() {
    return union_type("Client.Study.AnalysisForm.Types.InternalMsg", [], InternalMsg, () => [[["Item", LocalMsg_$reflection()]], [["Item", InboundMsg_$reflection()]]]);
}

export class MsgAnalysis extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Internal", "External"];
    }
}

export function MsgAnalysis_$reflection() {
    return union_type("Client.Study.AnalysisForm.Types.MsgAnalysis", [], MsgAnalysis, () => [[["Item", InternalMsg_$reflection()]], [["Item", OutboundMsg_$reflection()]]]);
}

export function wrapLocalMsg(msg) {
    return new MsgAnalysis(0, [new InternalMsg(0, [msg])]);
}

export class ModeAnalysis extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["List", "Create", "Edit", "Saving", "Detail", "ReportTypeSelection"];
    }
}

export function ModeAnalysis_$reflection() {
    return union_type("Client.Study.AnalysisForm.Types.ModeAnalysis", [], ModeAnalysis, () => [[], [], [], [], [], []]);
}

export class PatientInfo extends Record {
    constructor(patientInfoId, patientInstitution) {
        super();
        this.patientInfoId = patientInfoId;
        this.patientInstitution = patientInstitution;
    }
}

export function PatientInfo_$reflection() {
    return record_type("Client.Study.AnalysisForm.Types.PatientInfo", [], PatientInfo, () => [["patientInfoId", class_type("System.Guid")], ["patientInstitution", InstitutionViewModel_$reflection()]]);
}

export function PatientInfo_get_patientInfoId_() {
    return [(m) => m.patientInfoId, (v) => ((m_1) => (new PatientInfo(v, m_1.patientInstitution)))];
}

export function PatientInfo_get_patientInstitution_() {
    return [(m) => m.patientInstitution, (v) => ((m_1) => (new PatientInfo(m_1.patientInfoId, v)))];
}

export class ModelAnalysis extends Record {
    constructor(Mode, EditAnalysisVm, UserRoles, SelectedStudyAnalysis, SelectedStudy, StudyDataFileManager, IntermediateZipFileManager, UiDataFileManager, FileUpdateArgs, ActivePatientInfo, IsValid, ReportGenerationType, IdentifiedPatientInfo, ReportInfoIsValid) {
        super();
        this.Mode = Mode;
        this.EditAnalysisVm = EditAnalysisVm;
        this.UserRoles = UserRoles;
        this.SelectedStudyAnalysis = SelectedStudyAnalysis;
        this.SelectedStudy = SelectedStudy;
        this.StudyDataFileManager = StudyDataFileManager;
        this.IntermediateZipFileManager = IntermediateZipFileManager;
        this.UiDataFileManager = UiDataFileManager;
        this.FileUpdateArgs = FileUpdateArgs;
        this.ActivePatientInfo = ActivePatientInfo;
        this.IsValid = IsValid;
        this.ReportGenerationType = ReportGenerationType;
        this.IdentifiedPatientInfo = IdentifiedPatientInfo;
        this.ReportInfoIsValid = ReportInfoIsValid;
    }
}

export function ModelAnalysis_$reflection() {
    return record_type("Client.Study.AnalysisForm.Types.ModelAnalysis", [], ModelAnalysis, () => [["Mode", ModeAnalysis_$reflection()], ["EditAnalysisVm", AnalysisViewModel_$reflection()], ["UserRoles", list_type(UserRole_$reflection())], ["SelectedStudyAnalysis", AnalysisViewModel_$reflection()], ["SelectedStudy", StudyViewModel_$reflection()], ["StudyDataFileManager", Model_$reflection()], ["IntermediateZipFileManager", option_type(Model_$reflection())], ["UiDataFileManager", Model_$reflection()], ["FileUpdateArgs", option_type(tuple_type(class_type("Fable.Import.Aws.Credentials.Credentials"), S3Context_$reflection()))], ["ActivePatientInfo", PatientInfo_$reflection()], ["IsValid", bool_type], ["ReportGenerationType", Common_ReportType_$reflection()], ["IdentifiedPatientInfo", PatientCreationViewModel_$reflection()], ["ReportInfoIsValid", bool_type]]);
}

export function ModelAnalysis_get_activePatientInfo_() {
    return [(m) => m.ActivePatientInfo, (v) => ((m_1) => (new ModelAnalysis(m_1.Mode, m_1.EditAnalysisVm, m_1.UserRoles, m_1.SelectedStudyAnalysis, m_1.SelectedStudy, m_1.StudyDataFileManager, m_1.IntermediateZipFileManager, m_1.UiDataFileManager, m_1.FileUpdateArgs, v, m_1.IsValid, m_1.ReportGenerationType, m_1.IdentifiedPatientInfo, m_1.ReportInfoIsValid)))];
}

export function ModelAnalysis_get_identifiedPatientInfo_() {
    return [(m) => m.IdentifiedPatientInfo, (v) => ((m_1) => (new ModelAnalysis(m_1.Mode, m_1.EditAnalysisVm, m_1.UserRoles, m_1.SelectedStudyAnalysis, m_1.SelectedStudy, m_1.StudyDataFileManager, m_1.IntermediateZipFileManager, m_1.UiDataFileManager, m_1.FileUpdateArgs, m_1.ActivePatientInfo, m_1.IsValid, m_1.ReportGenerationType, v, m_1.ReportInfoIsValid)))];
}

